// extracted by mini-css-extract-plugin
export default {"subtitle":"index_subtitle__5Lrab","label":"index_label__Jf6xZ","icon":"index_icon__+mWNU"};